module.exports = __webpack_public_path__ + "img/left-baner.6819541e.png";